<template>
  <div :class="classNames" role="button" :title="name" @click="onClick">
    <svg v-if="icon && typeof(icon) === 'object'" viewBox="0 0 24 24">
      <path :d="icon.d" />
    </svg>
    <i v-if="icon && typeof(icon) === 'string'" class="material-icons">{{icon}}</i>
    <span v-else v-html="name"></span>
  </div>
</template>

<script>
export default {
  name: 'CMButton',
  props: {
    icon: [String, Object],
    name: String,
    fn: Function,
    modifiers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    classNames () {
      const classes = {
        'cm-button': true,
        'cm-button--inactive': !this.fn && this.name !== 'More',
        'cm-button--icon': Boolean(this.icon)
      }
      this.modifiers.forEach(modifier => {
        classes[`cm-button--${modifier}`] = true
      })
      return classes
    }
  },
  methods: {
    onClick (ev) {
      if (this.fn) this.fn(ev)
    }
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
.cm-button
  background: transparent
  border: none
  border-radius: 4px
  position: relative
  height: 36px
  margin: 0
  padding: 0 16px
  display: inline-block
  font: $uiFont
  font-weight: 500
  letter-spacing: 0
  overflow: hidden
  will-change: box-shadow
  transition: box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), color 0.2s cubic-bezier(0.4, 0, 0.2, 1)
  outline: none
  cursor: pointer
  text-decoration: none
  text-align: center
  line-height: 36px
  vertical-align: middle
  cursor: pointer
  user-select: none
  &.cm-button--accent, &[type="accent"]
    background: $prominentTextColor
    color: white
    margin-left: 16px
    &:hover
      background: $prominentTextColorSelected
      color: white
  &.cm-button--compact
    padding: 0 8px
  &.cm-button--rounded
    border: 1px solid #999
    border-radius: 24px
    margin-right: 8px
    padding: 0 40px
  &.cm-button--warn
    background: rgba(219,68,55, 0.84)
    border-color: rgba(219,68,55, 1)
    color: white
    &:hover
      background: rgba(219,68,55, 1)
      border-color: rgba(219,68,55, 1)
      color: white
  &.cm-button--inactive
    cursor: default
  &:hover
    color: #333
    border-color: #333
  .mui-theme--dark &
    color: #fff
    border-color: #fff

  i.material-icons
    font-size: inherit
    .mui-theme--dark &
      color: #fff
      border-color: #fff
    // background-color: rgba(158,158,158, 0.20)
  .material-icons, svg
    vertical-align: middle
.cm-button--icon
  border-radius: 50%
  font-size: 24px
  height: auto
  margin: 0
  padding: 0
  overflow: hidden
  line-height: 1rem
  color: inherit
  fill: inherit
.cm-button--icon.active
  svg path, i
    fill: $prominentTextColor
    color: $prominentTextColor
.cm-button--icon.overlay
  margin: auto
  position: absolute
  top: 0
  left: 0
  bottom: 0
  right: 0
</style>



// WEBPACK FOOTER //
// src/components/CMButton.vue